import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { loginUser } from '../../Redux/actions/authActions'
import logo from '../../assets/pantrylogo.png'
import { Form, Icon, Input, Button, Upload, Select, Table, Switch, Avatar, message, notification, Popconfirm } from 'antd';
import Highlighter from 'react-highlight-words';
import Footer from '../../Components/Footer'
import SubmitButton from '../../Components/SubmitButton'
import moment from 'moment'
import axios from 'axios'
import { serverUrl } from '../../Config/api'


const { Option } = Select
const { TextArea } = Input

const title = "Error"
var expandData = []
var expandData2 = []
const saleType = ["A", "B", "C"]

const props = {
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    listType: 'picture'
};


class FAQ extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedRowKeys: [],
            loading: false,
            loading1: false,
            disable: false,
            filteredInfo: null,
            sortedInfo: null,
            searchText: '',
            searchedColumn: '',
            StartDateValue: '',
            EndDateValue: '',
            disableUpload: false,
            fileList: [],
            allData: [],
            allData2: [],
            userGroupData: [],
            userGroupData2: [],
            userGroupAll: [],
            tableData: [],
            tableData2: [],
            buSwitch: false,
            cuSwitch: false,
            buSwitch2: false,
            cuSwitch2: false
        }
    }

    async componentDidMount() {
        const { tableData, tableData2 } = this.state
        const { user } = this.props

        if (!user || user.role !== 'admin') {
            return this.props.history.replace('/login')
        }

        axios.get(`${serverUrl}/admin/get/get-faq1/${user._id}`)
            .then((res) => {
                const { data } = res.data
                for (var i in data) {
                    tableData.push({
                        key: data[i]._id,
                        faq: data[i].faq,
                        order: data[i].order,
                        action: data[i],
                        bu: data[i].buSwitch ? 'True' : 'False',
                        cu: data[i].cuSwitch ? 'True' : 'False',
                        delete: data[i]._id,
                        index: i
                    })
                }
                this.setState({ tableData, allData: data })
            })

        axios.get(`${serverUrl}/admin/get/get-faq2/${user._id}`)
            .then((res) => {
                const { data } = res.data
                for (var i in data) {
                    tableData2.push({
                        key: data[i]._id,
                        title: data[i].title,
                        order2: data[i].order2,
                        action: data[i],
                        bu2: data[i].buSwitch2 ? 'True' : 'False',
                        cu2: data[i].cuSwitch2 ? 'True' : 'False',
                        delete: data[i]._id,
                        index: i
                    })
                }
                this.setState({ tableData2, allData2: data })
            })
        await axios.get(`${serverUrl}/admin/get/get-user-group/${user._id}`)
            .then((res) => {
                const { data } = res.data
                this.setState({ userGroupAll: data })
            })
            .catch((e) => console.log(e))
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    };

    normFile = e => {
        this.setState({ disableUpload: false })
        if (e.file.type.indexOf('image')) {
            // this.openNotification(title, 'Please Upload an Image', 'close-circle', 'red')
            return
        }
        if (Array.isArray(e)) {
            return e;
        }
        if (e.fileList.length) {
            this.setState({ disableUpload: true, fileList: e.fileList })
        }
        return e && e.fileList;
    }

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    };

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    };

    setAgeSort = () => {
        this.setState({
            sortedInfo: {
                order: 'ascend',
                columnKey: 'title',
            },
        });
    };

    setAgeSort1 = () => {
        this.setState({
            sortedInfo: {
                order: 'ascend',
                columnKey: 'faq',
            },
        });
    };

    openNotification = (title, desc, icon, color = '#108ee9') => {
        notification.open({
            message: title,
            description: desc,
            icon: <Icon type={icon} style={{ color: color }} />,
        });
    };

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    expandedRowRender = () => {
        const columns = [
            {
                title: 'User Group',
                ellipsis: true,
                children: [
                    {
                        title: 'Name 1',
                        dataIndex: 'ug1',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 2',
                        dataIndex: 'ug2',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 3',
                        dataIndex: 'ug3',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 4',
                        dataIndex: 'ug4',
                        ellipsis: true,
                    }
                ]
            }
        ]
        const data = [{
            ug1: expandData[0],
            ug2: expandData[1] ? expandData[1] : '',
            ug3: expandData[2] ? expandData[2] : '',
            ug4: expandData[3] ? expandData[3] : '',
        }]
        return <Table columns={columns} dataSource={data} key={0} pagination={false} />;
    };

    expandedRowRender2 = () => {
        const columns = [
            {
                title: 'User Group',
                ellipsis: true,
                children: [
                    {
                        title: 'Name 1',
                        dataIndex: 'ug1',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 2',
                        dataIndex: 'ug2',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 3',
                        dataIndex: 'ug3',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 4',
                        dataIndex: 'ug4',
                        ellipsis: true,
                    }
                ]
            }
        ]
        const data = [{
            ug1: expandData2[0],
            ug2: expandData2[1] ? expandData2[1] : '',
            ug3: expandData2[2] ? expandData2[2] : '',
            ug4: expandData2[3] ? expandData2[3] : '',
        }]
        return <Table columns={columns} dataSource={data} key={0} pagination={false} />;
    };

    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    handleSubmit = e => {
        const { user, form } = this.props
        const { validateFields } = form
        e.preventDefault();
        validateFields(['faq', 'order', 'answer', 'userGroup', 'buSwitch', 'cuSwitch'], (err, values) => {
            if (!err) {
                this.setState({ disable: true, loading: true })
                values.userId = user._id
                values.country = user.country
                axios.post(`${serverUrl}/admin/post/add-faq1`, values)
                    .then((result) => {
                        if (result.data.success) {
                            this.openNotification('Success', result.data.message, 'check')
                            this.setState({ disable: false, loading: false })
                            window.location.reload()
                        }
                        else {
                            this.openNotification(title, result.data.message, 'close-circle', 'red')
                            this.setState({ disable: false, loading: false })
                        }
                    })
                    .catch((err) => {
                        this.openNotification(title, "OOPS Something went wrong!!!", 'close-circle', 'red')
                        this.setState({ disable: false, loading: false })
                    })
            }
        });
    };

    handleSubmit1 = e => {
        const { user } = this.props
        const { validateFields } = this.props.form
        e.preventDefault();
        validateFields(['title', 'order2', 'description', 'userGroup2', 'buSwitch2', 'cuSwitch2'], (err, values) => {
            if (!err) {
                this.setState({ loading1: true })
                values.userId = user._id
                values.country = user.country
                axios.post(`${serverUrl}/admin/post/add-faq2`, values)
                    .then((result) => {
                        if (result.data.success) {
                            this.openNotification('Success', result.data.message, 'check')
                            this.setState({ loading1: false })
                            window.location.reload()
                        }
                        else {
                            this.openNotification(title, result.data.message, 'close-circle', 'red')
                            this.setState({ loading1: false })
                        }
                    })
                    .catch((err) => {
                        this.openNotification(title, "OOPS Something went wrong!!!", 'close-circle', 'red')
                        this.setState({ loading1: false })
                    })
            }
        });
    };

    disabledEndDate(current) {
        return current < moment(this.state.StartDateValue).add(1, 'day')
    }

    disabledStartDate(current) {
        return current > moment(this.state.EndDateValue)
    }

    handleExpand = (row) => {
        const { allData } = this.state
        expandData = allData[row.index].userGroup
    }

    handleExpand2 = (row) => {
        const { allData2 } = this.state
        expandData2 = allData2[row.index].userGroup2
    }

    createCopyData(v) {
        const { setFieldsValue } = this.props.form
        setFieldsValue(v)
        this.setState({ ...v }, () => {
            this.updateUserGroupOne()
            this.updateUserGroupTwo()
        })
        this.openNotification('Success', 'Successfully Copy Data', 'check')
    }

    async deleteData(v) {
        let { tableData } = this.state
        await axios.get(`${serverUrl}/admin/get/del-faq1/${v}`)
            .then((res) => {
                const { data } = res
                if (data.success) {
                    tableData = tableData.filter(i => i.key !== v)
                    this.setState({ tableData })
                    this.openNotification('Success', 'Successfully Deleted Data', 'check')
                }
                else {
                    this.openNotification('Error', 'Something Went Wrong!!!', 'close-circle', 'red')
                }
            })
            .catch((e) => {
                this.openNotification('Error', 'Something Went Wrong!!!', 'close-circle', 'red')
            })
    }

    async deleteData2(v) {
        let { tableData2 } = this.state
        await axios.get(`${serverUrl}/admin/get/del-faq2/${v}`)
            .then((res) => {
                const { data } = res
                if (data.success) {
                    tableData2 = tableData2.filter(i => i.key !== v)
                    this.setState({ tableData2 })
                    this.openNotification('Success', 'Successfully Deleted Data', 'check')
                }
                else {
                    this.openNotification('Error', 'Something Went Wrong!!!', 'close-circle', 'red')
                }
            })
            .catch((e) => {
                this.openNotification('Error', 'Something Went Wrong!!!', 'close-circle', 'red')
            })
    }

    checkLimit(name) {
        const { getFieldValue, setFieldsValue } = this.props.form
        if (getFieldValue(name).length > 4) {
            this.openNotification('Error', 'You can only select Maximun 4!!!', 'close-circle', 'red')
            setFieldsValue({
                [name]: getFieldValue(name).slice(0, 4)
            })

            return false
        }

        return true
    }

    updateUserGroupOne() {
        const { buSwitch, cuSwitch, userGroupAll } = this.state
        let userGroupData = []
        for (var i of userGroupAll) {
            if (buSwitch && i.buSwitch || cuSwitch && i.cuSwitch) {
                userGroupData.push(i)
            }
        }
        this.setState({ userGroupData })
    }

    updateUserGroupTwo() {
        const { buSwitch2, cuSwitch2, userGroupAll } = this.state
        let userGroupData2 = []
        for (var i of userGroupAll) {
            if (buSwitch2 && i.buSwitch || cuSwitch2 && i.cuSwitch) {
                userGroupData2.push(i)
            }
        }
        this.setState({ userGroupData2 })
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        let { sortedInfo, filteredInfo, loading, disable, tableData, userGroupData, loading1, tableData2, buSwitch, cuSwitch, buSwitch2, cuSwitch2, userGroupData2 } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};

        const columns = [
            {
                title: 'FAQ',
                dataIndex: 'faq',
                sorter: (a, b) => a.faq.length - b.faq.length,
                sortOrder: sortedInfo.columnKey === 'faq' && sortedInfo.order,
                ellipsis: true,
                ...this.getColumnSearchProps('faq'),
            },
            {
                title: 'Order',
                dataIndex: 'order',
                ellipsis: true,
                sorter: (a, b) => a.order - b.order,
                sortOrder: sortedInfo.columnKey === 'order' && sortedInfo.order
            },
            {
                title: 'BU',
                dataIndex: 'bu',
                ellipsis: true
            },
            {
                title: 'CU',
                dataIndex: 'cu',
                ellipsis: true
            },
            {
                title: 'Operation',
                dataIndex: 'action',
                ellipsis: true,
                render: (v) => <Button onClick={() => this.createCopyData(v)}>Create</Button>
            },
            {
                title: 'Delete',
                dataIndex: 'delete',
                ellipsis: true,
                render: (v) => <Popconfirm
                    title="Are you sure delete this data?"
                    onConfirm={() => this.deleteData(v)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="danger">Delete</Button>
                </Popconfirm>
            }
        ];

        const columns2 = [
            {
                title: 'Title',
                dataIndex: 'title',
                sorter: (a, b) => a.title.length - b.title.length,
                sortOrder: sortedInfo.columnKey === 'title' && sortedInfo.order,
                ellipsis: true,
                ...this.getColumnSearchProps('title'),
            },
            {
                title: 'Order',
                dataIndex: 'order2',
                ellipsis: true,
                sorter: (a, b) => a.order2 - b.order2,
                sortOrder: sortedInfo.columnKey === 'order2' && sortedInfo.order
            },
            {
                title: 'BU',
                dataIndex: 'bu2',
                ellipsis: true
            },
            {
                title: 'CU',
                dataIndex: 'cu2',
                ellipsis: true
            },
            {
                title: 'Operation',
                dataIndex: 'action',
                ellipsis: true,
                render: (v) => <Button onClick={() => this.createCopyData(v)}>Create</Button>
            },
            {
                title: 'Delete',
                dataIndex: 'delete',
                ellipsis: true,
                render: (v) => <Popconfirm
                    title="Are you sure delete this data?"
                    onConfirm={() => this.deleteData2(v)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="danger">Delete</Button>
                </Popconfirm>
            }
        ];

        return (
            <div>
                <div className="advertisement">
                </div>

                <header className="header2 bg-light">
                    <nav className="navbar  navbar-light">
                        <div className="container">
                            <Link className="navbar-brand" to="/"><img src={logo} alt="logo" className="img-fluid" /></Link>
                            <div style={{ display: 'flex' }}>
                                <Link className="home-btn" to="/"><i className="fas fa-home"></i></Link>
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                            </div>
                            <div className="collapse navbar-collapse" id="collapsingNavbar">

                                <ul className="navbar-nav ml-auto">

                                    <li className="nav-item"><Link className="nav-link" to="/">Home</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/account">Profile</Link> </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Settings
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <a className="nav-link dropdown-toggle nav-link-child" href="#" id="navbarDropdownChild" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Delivery
                                            </a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownChild">
                                                <Link className="dropdown-item" to="/timeslot">TimeSlot</Link>
                                                <Link className="dropdown-item" to="/region">Region</Link>
                                                <Link className="dropdown-item" to="/costs">Costs</Link>
                                            </div>
                                            <Link className="dropdown-item" to="/grocery">Grocery</Link>
                                            <Link className="dropdown-item" to="/offer-type">OfferType</Link>
                                            <Link className="dropdown-item" to="/topic">Topic</Link>
                                            <Link className="dropdown-item" to="/user-group">UserGroup</Link>
                                            <Link className="dropdown-item" to="/product">Product</Link>
                                            <Link className="dropdown-item" to="/product-group">ProductGroup</Link>
                                            <Link className="dropdown-item" to="/product-type">ProductType</Link>
                                            <Link className="dropdown-item" to="/qanda">Question & Answer settings </Link>
                                            <Link className="dropdown-item" to="/focusgroup">Focusgroup settings</Link>
                                            <Link className="dropdown-item" to="/1to1">1 To 1 Offer settings</Link>
                                            <Link className="dropdown-item" to="/ad">Promotional Ads settings</Link>
                                        </div>
                                    </li>
                                    <li className="nav-item"><Link className="nav-link" to="/subscription">Subscriptions</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/insight">Insights</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/invoice">Invoices</Link> </li><li className="nav-item"><Link className="nav-link" to="/login">Logout</Link> </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>

                <div className="main-content-bg">
                    <section>
                        <section className="main-content-bg2">
                            <div className="center1">
                                <div className="card2">
                                    <h2><b>OVERVIEW</b></h2>
                                    <br />
                                    <h4><b>FAQ 1</b></h4>
                                    <br />
                                    <br />
                                    <Table
                                        className="components-table-demo-nested"
                                        columns={columns}
                                        dataSource={tableData}
                                        onChange={this.handleChange}
                                        expandedRowRender={this.expandedRowRender}
                                        onRow={(row, rowIndex) => this.handleExpand(row)}
                                        bordered
                                        title={() => <div className="table-operations">
                                            <Button onClick={this.setAgeSort1}>Sort FAQ</Button>
                                            <Button onClick={this.clearAll}>Clear sorters</Button>
                                        </div>}
                                        style={{ width: '100%' }}
                                        tableLayout="fixed"
                                        scroll={{ x: 1400, y: 300 }}
                                    />

                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <h4><b>Hoe het werkt</b></h4>
                                    <br />
                                    <br />
                                    <Table
                                        className="components-table-demo-nested"
                                        columns={columns2}
                                        dataSource={tableData2}
                                        onChange={this.handleChange}
                                        expandedRowRender={this.expandedRowRender2}
                                        onRow={(row, rowIndex) => this.handleExpand2(row)}
                                        bordered
                                        title={() => <div className="table-operations">
                                            <Button onClick={this.setAgeSort}>Sort Title</Button>
                                            <Button onClick={this.clearAll}>Clear sorters</Button>
                                        </div>}
                                        style={{ width: '100%' }}
                                        tableLayout="fixed"
                                        scroll={{ x: 1400, y: 300 }}
                                    />
                                </div>
                            </div>

                            <div className="center1">
                                <div className="card2">
                                    <Form
                                        className="login-form form-w"
                                        hideRequiredMark={true}
                                        onSubmit={this.handleSubmit}
                                        encType="multipart/form-data">
                                        <h1 className="heading1" >Form 1</h1>
                                        <Form.Item
                                            label="FAQ"
                                        >
                                            {getFieldDecorator('faq', {
                                                rules: [{ required: true, message: 'Please input FAQ!' }],
                                            })(
                                                <Input
                                                    type="text"
                                                    minLength={3}
                                                    placeholder="FAQ"
                                                />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="Order"
                                        >
                                            {getFieldDecorator('order', {
                                                rules: [{ required: true, message: 'Please input Order!' }],
                                            })(
                                                <Input
                                                    type="number"
                                                    minLength={3}
                                                    placeholder="Order"
                                                />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="Answer"
                                        >
                                            {getFieldDecorator('answer', {
                                                rules: [{ required: true, message: 'Please input Answer!' }],
                                            })(
                                                <Input
                                                    type="text"
                                                    minLength={3}
                                                    placeholder="Answer"
                                                />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="BU"
                                        >
                                            {getFieldDecorator('buSwitch', {
                                                initialValue: false
                                            })(
                                                <Switch checked={buSwitch} onChange={e => this.setState({ buSwitch: e }, () => this.updateUserGroupOne())} />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="CU"
                                        >
                                            {getFieldDecorator('cuSwitch', {
                                                initialValue: false
                                            })(
                                                <Switch checked={cuSwitch} onChange={e => this.setState({ cuSwitch: e }, () => this.updateUserGroupOne())} />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="User Group"
                                        >
                                            {getFieldDecorator('userGroup', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please Select User Group Name!'
                                                    }],
                                            })(
                                                <Select
                                                    showArrow
                                                    showSearch
                                                    mode="multiple"
                                                    style={{ backgroundColor: '#fff' }}
                                                    placeholder="Select User Group Name"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {
                                                        userGroupData.map((v, i) => {
                                                            return <Option value={v.name} key={i}>{v.name}</Option>
                                                        })
                                                    }
                                                </Select>,
                                            )}
                                        </Form.Item>
                                        <Form.Item>
                                            <SubmitButton loading={loading} disable={disable} />
                                        </Form.Item>
                                    </Form>
                                    <br />
                                    <Form
                                        className="login-form form-w"
                                        hideRequiredMark={true}
                                        onSubmit={this.handleSubmit1}
                                        encType="multipart/form-data">
                                        <h1 className="heading1" >Form 2</h1>
                                        <Form.Item
                                            label="Title"
                                        >
                                            {getFieldDecorator('title', {
                                                rules: [{ required: true, message: 'Please input Title!' }],
                                            })(
                                                <Input
                                                    type="text"
                                                    minLength={3}
                                                    placeholder="Title"
                                                />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="Order"
                                        >
                                            {getFieldDecorator('order2', {
                                                rules: [{ required: true, message: 'Please input Order!' }],
                                            })(
                                                <Input
                                                    type="number"
                                                    minLength={3}
                                                    placeholder="Order"
                                                />,
                                            )}
                                        </Form.Item>

                                        <Form.Item
                                            label="Description"
                                        >
                                            {getFieldDecorator('description', {
                                                rules: [{ required: true, message: 'Please input Description!' }],
                                            })(
                                                <TextArea rows={4} placeholder="Input Description Here!!!" />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="BU"
                                        >
                                            {getFieldDecorator('buSwitch2', {
                                                initialValue: false
                                            })(
                                                <Switch checked={buSwitch2} onChange={e => this.setState({ buSwitch2: e }, () => this.updateUserGroupTwo())} />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="CU"
                                        >
                                            {getFieldDecorator('cuSwitch2', {
                                                initialValue: false
                                            })(
                                                <Switch checked={cuSwitch2} onChange={e => this.setState({ cuSwitch2: e }, () => this.updateUserGroupTwo())} />,
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            label="User Group"
                                        >
                                            {getFieldDecorator('userGroup2', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please Select User Group Name!'
                                                    }],
                                            })(
                                                <Select
                                                    showArrow
                                                    showSearch
                                                    mode="multiple"
                                                    style={{ backgroundColor: '#fff' }}
                                                    placeholder="Select User Group Name"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {
                                                        userGroupData2.map((v, i) => {
                                                            return <Option value={v.name} key={i}>{v.name}</Option>
                                                        })
                                                    }
                                                </Select>,
                                            )}
                                        </Form.Item>
                                        <Form.Item>
                                            <SubmitButton loading={loading1} />
                                        </Form.Item>
                                    </Form>
                                </div>
                            </div>
                        </section>
                        <Footer {...this.props} />
                    </section>
                </div>
            </div>
        )
    }
}

const FAQForm = Form.create({ name: 'normal_login' })(FAQ);

const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loginUser: (user) => dispatch(loginUser(user)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(FAQForm)